var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0004 3.1333L25.3337 5.79997M15.187 15.9466L20.667 10.4666M20.667 10.4666L24.667 14.4666L29.3337 9.79997L25.3337 5.79997M20.667 10.4666L25.3337 5.79997M15.187 15.9466C15.8755 16.6259 16.4228 17.4347 16.7974 18.3264C17.172 19.218 17.3665 20.175 17.3697 21.1421C17.373 22.1093 17.1849 23.0675 16.8163 23.9617C16.4476 24.8559 15.9058 25.6683 15.2219 26.3522C14.538 27.036 13.7256 27.5779 12.8314 27.9465C11.9373 28.3151 10.979 28.5032 10.0119 28.5C9.04472 28.4968 8.08776 28.3022 7.19609 27.9276C6.30442 27.553 5.49565 27.0058 4.81637 26.3173C3.48054 24.9342 2.74138 23.0818 2.75809 21.159C2.7748 19.2362 3.54604 17.397 4.9057 16.0373C6.26536 14.6776 8.10465 13.9064 10.0274 13.8897C11.9502 13.873 13.8026 14.6121 15.1857 15.948L15.187 15.9466Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatIconKey);
export default __webpack_public_path__ + "static/media/gat-icon-key.21988b139c1f029471b13a874c9bc527.svg";
export { ForwardRef as ReactComponent };